import React from "react";
import Heading from "../common/ui/Heading";
import { OUR_PRODUCT_LIST } from "../../utils/other-component";

const OurProduct = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-16">
        <div className="flex items-center justify-center flex-col">
          <Heading
            children="Our Products: Transforming Health & Wellness"
            className="max-w-[688px] text-center"
          />
        </div>
        <div className="max-w-[1140px] flex max-xl:gap-5 max-md:flex-wrap  max-lg:pt-10 max-md:pt-6 justify-between mx-auto pt-[50px]">
          {OUR_PRODUCT_LIST.map((obj, i) => (
            <div
              key={i}
              className="border border-solid border-[#0101011A] max-md:mx-auto rounded-2xl w-full max-w-[558px] p-4 h-[449px] bg-[#FEFEFE]"
            >
              <img
                src={obj.img}
                alt="item-img"
                className="w-full max-w-[526px] pointer-events-none"
              />
              <h2 className="text-[#001A3D] font-bold text-2xl leading-[120%] pt-4">
                {obj.title}
              </h2>
              <p className="text-[#5E5C5C] text-base font-normal leading-[150%] pt-[10px]">
                {obj.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default OurProduct;
